import React from 'react'
import { Card, CardBody } from 'reactstrap'
import Avatar from '../../../../assets/img/default_avatar.png'
import './style.css'
import { useSelector } from 'react-redux'

const getRoleName = (access, language) => {
  switch (access) {
    case 1:
      return language.settings ? language.settings.admin : 'Admin'
    case 2:
      return language.settings
        ? language.settings.course_manager
        : 'Course Manager'
    case 3:
      return language.settings ? language.settings.employee : 'Employee'
    case 4:
      return language.settings ? language.settings.area_admin : 'Area Admin'
    case 5:
      return 'Region Manager'
    default:
      return 'Employee'
  }
}

function DashboardProfile({ user }) {
  const languageRedux = useSelector((state) => state.language?.language?.data)

  const language = languageRedux || {}

  return (
    <Card className='h-100 '>
      <CardBody>
        {/* {console.log('test')} */}
        <img
          alt='...'
          className='rounded-circle p-2 img-center img-fluid shadow shadow-lg--hover bg-gray '
          src={user.avatar ? user.avatar.url : Avatar}
          style={{
            width: '203px',
            height: '203px',
            objectFit: 'cover',
          }}
        />
        <div className='pt-4 text-center'>
          <h5 className='h3 title'>
            <span className='d-block mb-1'>
              {user.first_name + ' ' + user.last_name}
            </span>
            <small className='h4 font-weight-light text-muted'>
              {user.location || 'No Location'}
            </small>
            <p>{getRoleName(user && user.access, language)}</p>
          </h5>
        </div>
      </CardBody>
    </Card>
  )
}

export default DashboardProfile
